//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axiosApi from "@/request/index";
import footerNav from "@/components/footerNav";
import headDetails from "@/components/headDetails";
import { uploadFile } from "@/utils/auth";
import { Dialog, Toast } from "vant";
import homeTip from "@/components/homeTip";

export default {
  name: "procurementClearance",
  components: {
    footerNav,
    homeTip,
    headDetails
  },
  data() {
    return {
      id: "",
      num: "",
      XiaBiao: "",
      edittime: false,
      isedit: false,
      date: "",
      show: false,
      IssuedLoading: false,
      rejectedLoading: false,
      throughLoading: false,
      submitLoading: false,
      rejected: false,
      through: false,
      submit: false,
      Issued: false,
      planOrderId: "",
      basicForm: {
        secondDeptName: "",
        planOrderSn: "",
        planQty: "",
        issueNum: "",
        procurementList: []
      },
      price: "",
      planQty: "",
      issueNum: "",
      rejectRemark: "驳回",
      size: 10,
      start: 0,
      total: 0
    };
  },
  created() {
    if (this.$route.query.item) {
      this.planOrderId = this.$route.query.item.planOrderId;
      this.planQty = this.$route.query.item.planQty;
      this.issueNum = this.$route.query.item.issueNum;
    }
    if (this.$route.query.type == "edit") {
      this.isedit = true;
    }
    this.queryData();
  },
  mounted() {
    if (this.$route.query.type == "view") {
      this.rejected = false;
      this.through = false;
    }
  },
  methods: {
    down() {
      this.rejectedLoading = false;
    },
    throughClick() {
      this.throughLoading = true;
      axiosApi
        .purchaseAudit({
          planOrderIdList: [this.planOrderId],
          planStatus: 3,
          rejectRemark: ""
        })
        .then(response => {
          this.throughLoading = false;
          this.$router.push({ name: "buyPlan" });
        })
        .catch(error => {
          this.throughLoading = false;
        });
    },
    submitClick() {
      this.submitLoading = true;
      axiosApi
        .purchaseUpdate({
          planOrderIdList: [this.planOrderId],
          planStatus: 1
        })
        .then(response => {
          this.$router.push({ name: "buyPlan" });
          this.submitLoading = false;
        })
        .catch(error => {
          this.submitLoading = false;
        });
    },
    rejectedClick() {
      this.rejectedLoading = true;
      axiosApi
        .purchaseAudit({
          planOrderIdList: [this.planOrderId],
          planStatus: 4,
          rejectRemark: "驳回"
        })
        .then(response => {
          this.rejectedLoading = false;
          this.$router.push({ name: "buyPlan" });
        })
        .catch(error => {
          this.rejectedLoading = false;
        });
    },
    IssuedClick() {
      this.rejectedLoading = true;
      this.$router.push({
        name: "buyPlanIssued",
        query: {
          planOrderId: this.planOrderId,
          planDetailList: JSON.stringify(this.$route.query.item)
        }
      });

      this.rejectedLoading = false;
    },
    queryData() {
      var queryParams = {
        planOrderId: this.planOrderId
      };
      axiosApi
        .queryPurchasePlan(queryParams)
        .then(response => {
          if (
            response.content.planStatus == 1 ||
            response.content.planStatus == 2
          ) {
            this.rejected = true;
            this.through = true;
          }
          if (response.content.planStatus == 0) {
            this.submit = true;
          }
          if (response.content.planStatus == 3) {
            this.Issued = true;
          }
          response.content.planQty = this.planQty;
          response.content.issueNum = this.issueNum;
          var data = response.content;
          for (var ind in data) {
            var val = data[ind] != null ? data[ind] : "";
            this.$set(this.basicForm, ind, val);
          }
          queryParams = {
            planOrderId: this.planOrderId,
            spuCodeList: [],
            skuCodeList: [],
            colorValueList: [],
            orderRules: [
              { orderKey: "spuCode", desc: false },
              { orderKey: "colorCode", desc: false },
              { orderKey: "sizeCode", desc: false },
              { orderKey: "t1.id", desc: true }
            ],
            start: (this.start - 1) * this.size,
            size: this.size
          };
          // 列表查询
          axiosApi
            .queryDetailList(queryParams)
            .then(response => {
              this.basicForm.procurementList = response.content.list;
              this.total = response.content.total;
            })
            .catch(error => {});
        })
        .catch(error => {});
    },
    editNum(id) {
      if (this.isedit) {
        for (let i = 0; i < this.basicForm.procurementList.length; i++) {
          if (this.basicForm.procurementList[i].id == id) {
            if (this.basicForm.procurementList[i].planQty == "") {
              this.basicForm.procurementList[i].planQty = 0;
            }
            this.XiaBiao = i;
          }
        }
        var queryParams = { ...this.basicForm.procurementList[this.XiaBiao] };
        axiosApi
          .updateDetail(queryParams)
          .then(response => {
            this.basicForm.planQty = response.content.planQty;
          })
          .catch(error => {});
      }
    },
    editPrice(id) {
      if (this.isedit) {
        for (let i = 0; i < this.basicForm.procurementList.length; i++) {
          if (this.basicForm.procurementList[i].id == id) {
            if (this.basicForm.procurementList[i].expectPrice == "") {
              this.basicForm.procurementList[i].expectPrice = 0;
            }
            this.XiaBiao = i;
          }
        }
        var queryParams = { ...this.basicForm.procurementList[this.XiaBiao] };
        axiosApi
          .updateDetail(queryParams)
          .then(response => {
            this.basicForm.planQty = response.content.planQty;
          })
          .catch(error => {});
      }
    },
    editTime(id) {
      if (this.isedit) {
        this.edittime = true;
        this.id = id;
      }
    },
    formatDate(date) {
      var month = (date.getMonth() + 1).toString().padStart(2, "0");
      var data = date
        .getDate()
        .toString()
        .padStart(2, "0");
      return `${date.getFullYear()}-${month}-${data} 00:00:00`;
    },
    onTime(date) {
      this.edittime = false;
      this.date = this.formatDate(date);
      for (let i = 0; i < this.basicForm.procurementList.length; i++) {
        if (this.basicForm.procurementList[i].id == this.id) {
          this.basicForm.procurementList[i].deliveryTime = this.date;
          this.XiaBiao = i;
        }
      }
      var queryParams = { ...this.basicForm.procurementList[this.XiaBiao] };
      axiosApi
        .updateDetail(queryParams)
        .then(response => {
          this.id = "";
          this.XiaBiao = "";
        })
        .catch(error => {});
    }
  }
};



// WEBPACK FOOTER //
// ./src/pages/buyPlan/buyPlanView.vue